import { render, staticRenderFns } from "./UserHostMembership.vue?vue&type=template&id=2984f4b9&scoped=true&"
import script from "./UserHostMembership.vue?vue&type=script&lang=ts&"
export * from "./UserHostMembership.vue?vue&type=script&lang=ts&"
import style0 from "./UserHostMembership.vue?vue&type=style&index=0&id=2984f4b9&prod&scoped=true&lang=scss&"
import style1 from "./UserHostMembership.vue?vue&type=style&index=1&id=2984f4b9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2984f4b9",
  null
  
)

export default component.exports